<template>

<div class="group-videos container">
    <div class="columns is-multiline">

        <gv-item v-for="item in items"
        :item="item" :key="item.id">
        </gv-item>

    </div>
</div>

</template>

<script>
import GvItem from "./GvItem.vue";

export default {
  name: `GroupVideos`,
  props: {
    items: Array
  },
  components: {
    GvItem
  }
};
</script>

<style lang="scss">
$purple: #656b85;
$crimsonish: #976177;
$red: #cc444b;
$pinky: #fd7170;
$black: #191919;

.group-videos {
  padding-bottom: 20px;
}

.group-video {
  background-color: #ffffff;

  .content {
    padding: 15px;
    position: relative;

    h4 {
      font-weight: 300;
      margin-bottom: 0;
      font-size: 1rem;
    }

    h3 {
      color: $purple;
      font-weight: 300;
      margin-top: 10px;
      font-size: 1.3rem;
    }
    h5.crimson {
      color: $crimsonish;
      font-weight: 300;
    }
    hr {
      margin: 5px 0;
    }

    .star {
      position: absolute;
      top: 10px;
      left: 10px;
      color: $black;
      font-size: 24px;
      transition: all 300ms ease;
      &:hover {
        color: $pinky;
        text-decoration: none;
      }
    }
    .star-selected {
      color: $pinky;
    }
  }
}
</style>
